;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('CandidateApplicationController', [
      'sharedProperties',
      '$location',
      'usSpinnerService',
      `SharedApi`,
      `CandidateApplicationApi`,
      `$scope`,
      'userService',
      'PositionApi',
      function controller(
        sharedProperties,
        $location,
        usSpinnerService,
        SharedApi,
        CandidateApplicationApi,
        $scope,
        userService,
        PositionApi
      ) {
        let vm = this

        vm.spinnerActive = false
        vm.startSpin = () => {
          if (!vm.spinnerActive) {
            usSpinnerService.spin('spinner-2')
            vm.spinnerActive = true
          }
        }

        vm.stopSpin = () => {
          if (vm.spinnerActive) {
            usSpinnerService.stop('spinner-2')
            vm.spinnerActive = false
          }
        }

        vm.paginationOptions = {
          limitOptions: [10, 20, 50],
          selectedLimit: 10,
        }

        vm.pagination = {
          currentPage: 0,
          totalItems: 0,
        }

        vm.showSuccessMsg = false
        vm.showErrorMsg = false
        vm.alertMsg = ''
        vm.showNoJobs = false
        vm.showInfo = false
        vm.firms = []
        vm.lawyerJobs = []
        vm.picSrc = 'images/firm-logo-default.jpg'
        vm.showClass = ''

        vm.applicationsPageChange = async () => {
          await vm.getCandidateApplication(vm.userId)
        }

        vm.getCandidateApplication = async userId => {
          vm.startSpin()
          const getCandidateApplicationDto = {
            user: [userId],
            include: ['position', 'employer', 'stage'],
            limit: vm.paginationOptions.selectedLimit,
            page: vm.pagination.currentPage,
          }

          const candidateApplications = await CandidateApplicationApi.getCandidateApplications(
            getCandidateApplicationDto
          )
          const totalApplicationsCount = await CandidateApplicationApi.getApplicationsCount(
            userId
          )
          vm.pagination.totalItems = totalApplicationsCount

          if (candidateApplications.status === 200) {
            const withoutOffPlatformSpeculativeConnect = candidateApplications.data
              .filter(Boolean)
              .filter(application => {
                // Filter out invisible employers and positions
                return (
                  application.positionVisible && application.employerVisible
                )
              })
              .filter(application => {
                // Filter out off-platform spec/connect
                const isSpecConnect = ['Speculative', 'Connect'].includes(
                  application.positionType
                )
                const isOffPlatform = application.isOffPlatform
                const result = !(isSpecConnect && isOffPlatform)
                console.debug(
                  'getApplications filter:',
                  application,
                  `isSpecConnect: ${isSpecConnect}`,
                  `isOffPlatform: ${isOffPlatform}`,
                  `result: ${result}`
                )
                return result
              })

            vm.candidatePositions = {
              candidate: {
                positions: withoutOffPlatformSpeculativeConnect,
              },
            }

            if (vm.candidatePositions.candidate.positions.length <= 0) {
              vm.showNoJobs = true
              vm.mainAlert =
                'You will be able to track your applications on this page.'
            } else {
              vm.showInfo = true
            }

            vm.candidatePositions.candidate.positions.forEach(
              async position => {
                position.employerLogoSrc = position.employerLogo
                  ? `${process.env.PUBLIC_BUCKET_URL}/employers/${position.employerId}/logo/${position.employerLogo}`
                  : vm.picSrc
                position.liveStatus = 'Live Jobs'
                position.positionDescription = 'Loading...'
                position.loaded = false
                position.locations =
                  position.positionLocations.length > 0
                    ? vm.locationsList
                        .filter(({id}) =>
                          position.positionLocations.find(
                            location => location === id
                          )
                        )
                        .map(location => ({
                          name: location.name,
                          parent: location.parent,
                          color: location.country.region.color,
                        }))
                    : []
              }
            )

            $scope.$applyAsync()
          }

          vm.stopSpin()

          if (candidateApplications.status === 440) {
            $location.url('/signin')
          }
        }

        vm.showJobDetail = async job => {
          if (job.expanded) {
            job.expanded = false
          } else {
            job.expanded = true
            job.isExpanded = false
            if (!job.loaded) {
              const {data} = await PositionApi.getPositionById(job.positionId)

              job.positionDescription = data.description
              job.loaded = true
            }

            // eslint-disable-next-line angular/controller-as
            $scope.$digest()
          }
        }

        vm.initializeCandidateApplication = async () => {
          const user = await userService.getUser()
          const {data: locationsList} = await SharedApi.getAllLocations({
            supported: true,
            regions: true,
          })
          vm.locationsList = locationsList
          vm.userId = user.id

          await vm.getCandidateApplication(user.id)

          vm.contact = {
            email:
              user.agent && user.agent.email
                ? user.agent.email
                : 'jobs@lexstep.com',
            phone:
              user.agent && user.agent.phone
                ? user.agent.phone
                : '+442039977000',
          }
        }

        vm.initializeCandidateApplication()
      },
    ])
})()



// WEBPACK FOOTER //
// ./scripts/candidate-applications/candidate-application.ctrl.js